const SubCompanyList = ({ subCompanyList }) => {
  const style = {
    display: subCompanyList ? "block" : "none",
  };

  return (
    <div className="forHide">
      <ul style={style} className="list block2">
        <li>history</li>
        <li>our team</li>
        <li>blog</li>
      </ul>
    </div>
  );
};
export default SubCompanyList;
